<template>
  <div class="edit-home-item">
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <HomeListItemForm
      v-model="listItem"
      @submit="updateListItem"
    />
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import HomeListItemForm from '@/components/SiteSetup/HomeListItemForm'

import {
  readCompanySitePageListListItemData,
  updateCompanySitePageListListItemData
} from '@/lib/list_items'

export default {
  name: 'editHomeContent',

  data() {
    return {
      listItem: {},
      errors: {},
      title: 'Edit Item'
    }
  },

  mixins: [page, notification],

  props: {
    companyId: String,
    siteId: String,
    pageId: String,
    listId: String,
    index: String,
    listItemId: String
  },

  methods: {
    getData() {
      readCompanySitePageListListItemData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        this.listItemId
      ).then(({data}) => {
        this.listItem = data
      })
    },

    updateListItem(data) {
      let listItem = {
        id: this.listItem.id,
        key: this.listItem.key,
        value: data,
        weight: this.listItem.weight
      }

      updateCompanySitePageListListItemData(
        this.companyId,
        this.siteId,
        this.pageId,
        this.listId,
        this.listItemId,
        listItem
      )
        .then(({data}) => {
          this.triggerNotification('success', 'item', 'updated')

          window.setTimeout(() => {
            this.$router.push({
              name: 'showHomeContent',
              params: {
                companyId: this.companyId,
                siteId: this.siteId,
                pageId: this.pageId,
                listId: this.listId,
                index: this.index,
                listItemId: this.listItemId
              }
            })
          }, 3000)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  },

  components: {
    HomeListItemForm
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'
</style>
